import { PureComponent } from 'react';

import PropTypes from 'prop-types';
import AddRow from './AddRow';
import Row from './Row';

/**
 * Renders the row, column layout based on the layout provided to the dashboard.
 */

export default class LayoutRenderer extends PureComponent {
  static propTypes = {
    addWidgetComponent: PropTypes.func,
    droppableColumnClass: PropTypes.string,
    editable: PropTypes.bool,
    editableColumnClass: PropTypes.string,
    frameComponent: PropTypes.func,
    layout: PropTypes.object,
    msg: PropTypes.object.isRequired,
    onAdd: PropTypes.func,
    onAddRow: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired,
    onMove: PropTypes.func,
    onMoveColumn: PropTypes.func.isRequired,
    onMoveWidget: PropTypes.func.isRequired,
    onRemove: PropTypes.func,
    onRemoveRow: PropTypes.func.isRequired,
    onSortColumns: PropTypes.func.isRequired,
    onSortWidgets: PropTypes.func.isRequired,
    onToggleConfirmDialog: PropTypes.func.isRequired,
    onUpdateColumnProperty: PropTypes.func.isRequired,
    rowClass: PropTypes.string,
    titlePlaceholder: PropTypes.string.isRequired,
    widgets: PropTypes.object,
  };

  static defaultProps = {
    /**
     * Default layout.
     */
    layout: {
      rows: [],
    },
  };

  render() {
    const {
      addWidgetComponent,
      droppableColumnClass,
      editable,
      editableColumnClass,
      frameComponent,
      layout,
      msg,
      onAdd,
      onAddRow,
      onEdit,
      onMove,
      onMoveColumn,
      onMoveWidget,
      onRemove,
      onRemoveRow,
      onSortColumns,
      onSortWidgets,
      onToggleConfirmDialog,
      onUpdateColumnProperty,
      rowClass,
      titlePlaceholder,
      widgets,
    } = this.props;

    const rows = layout.rows.map((row, rowIndex) => {
      return (
        <Row
          addWidgetComponent={addWidgetComponent}
          columns={row.columns}
          columnsLength={row.columns.length}
          droppableColumnClass={droppableColumnClass}
          editable={editable}
          editableColumnClass={editableColumnClass}
          frameComponent={frameComponent}
          key={row.key || rowIndex}
          layout={layout}
          msg={msg}
          onAdd={onAdd}
          onAddRow={onAddRow}
          onEdit={onEdit}
          onMove={onMove}
          onMoveColumn={onMoveColumn}
          onMoveWidget={onMoveWidget}
          onRemove={onRemove}
          onRemoveRow={onRemoveRow}
          onSortColumns={onSortColumns}
          onSortWidgets={onSortWidgets}
          onToggleConfirmDialog={onToggleConfirmDialog}
          onUpdateColumnProperty={onUpdateColumnProperty}
          rowClass={rowClass}
          rowIndex={rowIndex}
          titlePlaceholder={titlePlaceholder}
          widgets={widgets}
        />
      );
    });

    return (
      <div>
        {editable && (
          <AddRow
            msg={msg}
            rowIndex={0}
            noRows={rows.length === 0}
            onAddRow={onAddRow}
          />
        )}
        {(rows.length > 0 || editable) && rows}
        {rows.length === 0 && !editable && (
          <div className='dazzle__empty-dashboard'>
            <h3>Welcome to Dashboard!</h3>
            <p>
              Dashboard lets you know the network infrastructure status in one
              place.
            </p>
          </div>
        )}
      </div>
    );
  }
}
